import {Ref, ref, watch, defineEmits, onMounted} from 'vue'
import {TableOrder} from "@/types";


export default function Lista(manager: any, cols: any[], method?: any, storageKey?: string): any {

    const timeout = ref(0);
    const loading = ref(false);
    const infiniteIdentifier = ref(false);
    const sort = ref('');
    const keySearch = ref(storageKey ?? '');
    const search = ref('');
    const rows = ref([] as any[]);
    const callBinds: Ref<any[]> = ref([]);
    const paginate: Ref<any> = ref({})
    const apiParams: Ref<any> = ref({});
    const enableHistory = ref(true);
    const apiMethod = method || manager.paginatedList

    const debounceSearch = () => {
        if (timeout.value) {
            clearTimeout(timeout.value)
            timeout.value = 0
        }
        //qui fetcho sempre la prima pagina quindi devo resettare l'infinite scroll
        // @ts-ignore
        timeout.value = setTimeout(function () {
            fetchData().finally(() => {
                infiniteIdentifier.value = !infiniteIdentifier.value
            })
        }, 500)
    }

    const searchParam = () => {
        return {
            q: search.value,
        }
    }

    const setSearch = (s: string) => {
        search.value = s
    }

    const fetchData = (page?: number) => {
        loading.value = true
        return apiMethod(...callBinds.value, {
            params: {
                page,
                sort: sort.value, ...searchParam(), ...apiParams.value
            }
        }).then((response: any) => {
            const {data, ...pag} = response.data;
            if (page && page > 1) {
                rows.value.push(...data)
            } else {
                rows.value.splice(0, rows.value.length, ...data)
            }
            paginate.value = pag
        }).finally(() => {
            loading.value = false
        })
    }


    const fetchNextPage = (state: any) => {
        if (paginate.value.current_page) {
            if (paginate.value.current_page < paginate.value.last_page) {
                fetchData(++paginate.value.current_page).then(() => {
                    state.loaded()
                }).catch(() => {
                    state.error()
                })
            } else {
                state.complete()
            }
        } else {
            state.loaded()
        }
    }

    const updateCols = (ord: any) => {
        switch (ord.ord) {
            case TableOrder.ASC:
                sort.value = cols[ord.col].ordProp || cols[ord.col].prop
                break;
            case TableOrder.DESC:
                sort.value = `-${cols[ord.col].ordProp || cols[ord.col].prop}`
                break;
            case TableOrder.NONE:
                sort.value = ''
                break;
        }
        reset()
    }

    const reset = () => {
        infiniteIdentifier.value = !infiniteIdentifier.value
        return fetchData(1);
    }

    const setHistory = (enabled: boolean) => {
        enableHistory.value = enabled
    }

    watch(search, async (newSearch, oldSearch) => {
        if (keySearch.value) {
            localStorage.setItem(`${keySearch.value}.search`, newSearch ?? '')
        }
    })

    watch(sort, async (newSort, oldSearch) => {
        if (keySearch.value) {
            localStorage.setItem(`${keySearch.value}.sort`, newSort ?? '')
        }
    })

    onMounted(() => {
        if (keySearch.value) {
            const src = localStorage.getItem(`${keySearch.value}.search`)
            if (src) {
                search.value = src
            }
            const srt = localStorage.getItem(`${keySearch.value}.sort`)
            if (srt) {
                sort.value = srt
            }
        }
    })

    return {
        callBinds,
        loading,
        sort,
        rows,
        paginate,
        search,
        infiniteIdentifier,
        apiParams,
        enableHistory,
        keySearch,
        setSearch,
        debounceSearch,
        updateCols,
        fetchNextPage,
        fetchData,
        reset,
        searchParam
    }
}
